<template>
  <div class="info main-view">
    <div class="info-container">
      <div class="text-col">
        <h2>
          Refinitiv Trade Discovery
        </h2>

        <p>
          In January 2019 the BCBS published revised Minimum capital requirements for market risk. These requirements mandated those institutions seeking internal model approval status to check the activity associated with the risk factors adopted in their models. This compliance test is called the risk factor eligibility test (RFET).
        </p>

        <p>
          The Refinitiv Trade Discovery aims to support banks pass RFET through the provision of "real" price observations.
        </p>

        <p>
          This application allows you to select your chosen sources of "real" price observation data and then define your instrument to risk factor mapping and review the results. For continuous attributes such as maturity,  you can define custom buckets or adopt the pre-defined regulatory bucketing approach. You can then  optimise your data sources and preferred bucketing methodology by comparing different scenarios within the application and export the results for further analysis.
        </p>

        <button class="button button-primary" @click="start()">
          Start Using Trade Discovery
        </button>
      </div>

      <div class="image-col">
        <img src="./../assets/td_3d.png" alt="Picture of a graph">
      </div>
    </div>
    
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import Env from '@/services/env.service';

@Component({
  components: {
  },
})
export default class Info extends Vue {
  get environment() {
    return Env.get('VUE_APP_ENVIRONMENT');
  }

  public start() {
    this.$router.push('/calculator');
  }
}
</script>
<style scoped lang="scss">
  .info {
    display: flex;
    .info-container {
      width: 100%;
      max-width: 1200px;
      display: flex;
      margin: 0 auto;

      > div {
        flex: 1;
      }

      .text-col {
        display: flex;
        flex-direction: column;
        justify-content: center;

        p {
          margin-top: 20px;
        }

        .button {
          align-self: flex-start;
          margin-top: 30px;
        }
      }
      .image-col {
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;

        img {
          min-width: 1px;
        }
      }
    }
  }
</style>